import { DetailFieldConfig } from "../Utilities";

export default function DetailField({
  field,
  value,
}: {
  field: DetailFieldConfig;
  value: any;
}) {
  return (
    <div
      id={field.id}
      className={`text-xl mb-3 flex ${value != null ? "block" : "hidden"}`}
    >
      <div className="-w-40  font-skyBold  -text-right">{field.label} </div>
      <span className="ml-2 font-skyRegular">
        {field.formatter ? field.formatter(value) : value}
      </span>
    </div>
  );
}
